export enum BrowserBase {
    chromium = 'Chromium',
    firefox = 'Firefox',
    safari = 'Safari',
    other = 'Other',
}
